import { Outlet, useLocation } from "react-router-dom";
import Header from "./header/Header";
import "./Page.scss";
import SideNavigation from "./SideNavigation";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";

const Page = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isViewerRoute =
    location.pathname === "/viewer" || location.pathname.startsWith("/viewer/");

  const showSideNavigation = isAuthenticated && !isViewerRoute;

  // Close mobile menu on navigation
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div
      className={`page ${isAuthenticated ? "with-header" : ""} ${
        showSideNavigation ? "with-sidebar" : ""
      }`}
    >
      <Header
        dashboard={true}
        mobileMenuOpen={mobileMenuOpen}
        onMenuToggle={() => setMobileMenuOpen((o) => !o)}
      />
      {showSideNavigation && (
        <SideNavigation
          isOpen={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        />
      )}
      <Outlet />
      {children}
    </div>
  );
};

export default Page;
